export default {
  lucky: {
    prizeAgain: 'Quay lại',
    prizeThanks: 'Chúc may mắn lần sau',
    remainingChance: 'Lượt quay còn lại',
    task: 'Nhiệm vụ',
    deposit: 'Nạp tiền',
    wager: 'Cược',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: 'Sưu tập thẻ',
    puzzleRound: 'Vòng {current}/{total}',
    puzzleReward: 'Phần thưởng hoàn thành {amount}',
    redeem: 'Đổi thưởng',
    redeemSuccess: 'Đổi thành công',
    redeemSuccessWithReward: 'Đổi thành công! Bạn đã nhận được {amount} {currency}',
    redeemFailed: 'Đổi thất bại',
    notComplete: 'Chưa hoàn thành, không thể đổi thưởng',
    drawFailed: 'Rút thất bại, vui lòng thử lại',
    gainLetter: 'Chúc mừng! Bạn đã nhận được chữ cái {letter}',
    gainBlock: 'Chúc mừng! Bạn đã nhận được hình {blockNo}',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: 'Mời',
    claimReward: 'Nhận',
    noChest: 'Không có rương',
    claimSuccess: 'Đã nhận {count} rương, {amount} {currency}',
    claimFailed: 'Nhận thất bại, vui lòng thử lại',
    modalTitle: 'Rương báu',
    modalSubtitle: 'Vuốt để xem tất cả',
    chipTodayClaimed: 'Đã nhận hôm nay',
    chipClaimable: 'Có thể nhận',
    chipLocked: 'Đã khóa',
    totalClaimedCount: 'Tổng số rương đã nhận',
    totalClaimedAmount: 'Tổng số tiền đã nhận',
    chestUnit: 'cái',
    claimAll: 'Nhận tất cả',
    goInvite: 'Mời bạn bè',
    claimSingleSuccess: 'Đã nhận {amount} {currency}',
    labelClaimed: 'Đã nhận',
    labelClaimable: 'Có thể nhận',
    labelLocked: 'Đã khóa',
  },
}
